module.exports = __webpack_public_path__ + "img/img2.801a4dfb.jpg";